import { render } from "./igOpen.vue?vue&type=template&id=b0a142ce"
import script from "./igOpen.vue?vue&type=script&lang=js"
export * from "./igOpen.vue?vue&type=script&lang=js"

import "./igOpen.vue?vue&type=style&index=0&id=b0a142ce&lang=css"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__